import React, { useState, useEffect, useContext } from "react";
import { Box, Grid } from "@mui/material";
import Navbar from "../../posnavbar/Navbar";
import "./settings.css";
import { redirect, useNavigate } from "react-router-dom";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import KeyboardIcon from "@mui/icons-material/Keyboard";
import LaptopIcon from "@mui/icons-material/Laptop";
import PaymentIcon from "@mui/icons-material/Payment";
import NetworkCheckIcon from "@mui/icons-material/NetworkCheck";
import useGetDevice from "../hooks/useGetDevice";
import TvIcon from "@mui/icons-material/Tv";
import useAuthModal from "../hooks/useAuthModal";
import LockResetIcon from "@mui/icons-material/LockReset";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import Swal from "sweetalert2";
import { UserCircleIcon, XCircleIcon, ShieldCheckIcon } from "@heroicons/react/20/solid";
import RolesPermissions from "./components/RolesPermissions";
import { MoonIcon } from "@heroicons/react/20/solid";
import { MapPinIcon } from "@heroicons/react/20/solid";
import { PrinterIcon } from "@heroicons/react/20/solid";
import { SignalIcon } from "@heroicons/react/20/solid";
import { PresentationChartLineIcon } from "@heroicons/react/20/solid";
import { WrenchScrewdriverIcon } from "@heroicons/react/20/solid";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/20/solid";
import { Bars3Icon } from "@heroicons/react/20/solid";
import { Account } from "./components/Account";
import { Peripherals } from "./components/Peripherals";
import PaymentTerminal from "./components/paymentTerminal";
import { DisplayModeSettings } from "./components/DisplaySettings";
import { PrinterConfigurationSettings } from "./components/PrinterConfiguration";
import { useSnackbar } from "../hooks/SnackbarProvider";
import { UserContext } from "../../../../App";
import { useSelector } from "react-redux";
import { getMobilePos } from "../all-products/redux/Reducers/paginationReducer";
import { emit } from "react-native-react-bridge/lib/web";
import ChangeTheme from "./components/ChangeTheme";
import NetworkConfig from "./components/networkConfig";
import QuickTroubleshoot from "./components/QuickTroubleshoot";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import PrinterAgent from "./components/PrinterAgent";

export const Settings = () => {
  const isMobile = useGetDevice();
  const navigate = useNavigate();
  const { renderAuthModal, openAuthModal } = useAuthModal();

  const showSnackbar = useSnackbar();
  const retailType = localStorage.getItem("retailType");
  const branchSubType = localStorage.getItem("branchSubType");
  const appConfig = JSON.parse(localStorage.getItem("appConfig"));
  const cloudPrintEnabled = appConfig?.all?.CLOUD_PRINT?.flag;

  // const [activeIndex, setActiveIndex] = useState(0);
  // const [activeTabComp, setActiveTabComp] = useState(<Account />);  //for rendering selected tab component
  const { activeTabComp, setActiveTabComp, activeIndex, setActiveIndex } = useContext(UserContext);
  const sessionId = localStorage.getItem("sessionId");

  let { color, setColor } = useContext(UserContext);
  const isMobilePos = useSelector(getMobilePos);

  const [arrowActiveTab, setArrowActiveTab] = useState(activeIndex);

  const newSwal = Swal.mixin({
    customClass: {
      confirmButton: "button button-success",
      cancelButton: "button button-error",
      container: "close-session-swal-container",
    },
    buttonsStyling: false,
  });

  const clearLC = () => {
    newSwal
      .fire({
        title: "Are you sure you want to clear the local storage?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Proceed",
        cancelButtonText: "Cancel",
        backdrop: "rgba(0,0,0,0.4)",
      })
      .then((result) => {
        if (result.isConfirmed) {
          openAuthModal(() => {
            localStorage.clear();
            newSwal.fire({
              title: "Cleared!",
              text: "Local storage has been cleared.",
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
            });
          });
        }
      });
  };

  const items = [
    {
      name: "Profile",
      redirect: () => setActiveTabComp(<Account />),
      icons: <UserCircleIcon className="icon-1" sx={{ fontSize: "1.5em", color: "#333" }} />,
      text: "Setup your account",
      hidden: false,
    },
    {
      name: "Roles & Permissions",
      redirect: () => setActiveTabComp(
        <RolesPermissions />
      ),
      icons: <ShieldCheckIcon className="icon-1" sx={{ fontSize: "1.5em", color: "#333" }} />,
      text: "View assigned roles and permissions",
      hidden: false,
    },
    {
      name: "Change Theme",
      redirect: () => setActiveTabComp(<ChangeTheme />),
      icons: <MoonIcon className="icon-1" sx={{ fontSize: "1.5em", color: "#333" }} />,
      text: "",
      hidden: false,
    },
    {
      name: "Select Location",
      redirect: () => handleLocation(),
      icons: <MapPinIcon className="icon-1" sx={{ fontSize: "1.5em", color: "#333" }} />,
      text: "",
      hidden: false,
    },
    {
      name: "End Day",
      redirect: () => handleEndDay(),
      icons: <XCircleIcon className="icon-1" sx={{ fontSize: "1.5em", color: "#333" }} />,
      text: "",
      hidden: false,
    },
    {
      name: "Peripherals",
      redirect: () => setActiveTabComp(<Peripherals />),
      icons: <PrinterIcon className="icon-1" sx={{ fontSize: "1.5em", color: "#333" }} />,
      text: "Setup your peripherals",
      hidden: false,
    },
    {
      name: "Payment Configuration",
      // redirect: () => navigate("/settings/payment/terminal"),
      redirect: () => setActiveTabComp(<PaymentTerminal />),
      icons: <SignalIcon className="icon-1" sx={{ fontSize: "1.5em", color: "#333" }} />,
      text: "Setup your payment terminal",
      hidden: false,
    },
    {
      name: "Performance",
      // redirect: () => navigate("/settings/network/configuration"),
      redirect: () => setActiveTabComp(<NetworkConfig />),
      icons: (
        <PresentationChartLineIcon className="icon-1" sx={{ fontSize: "1.5em", color: "#333" }} />
      ),
      text: "App Performance Profiler",
      statusText: localStorage.getItem("profilerSwitch"),
      hidden: false,
    },
    // {
    //   name: "Display Setting",
    //   // redirect: () => navigate("/settings/display-settings"),
    //   redirect: () => setActiveTabComp(<DisplayModeSettings />),
    //   icons: <TvIcon className="icon-1" sx={{ fontSize: "1.5em", color: "#333" }} />,
    //   text: "Change the display mode",
    //   hidden: isMobile,
    // },
    ...(retailType === "RESTAURANT"
      ? [
          {
            name: "Menu",
            redirect: () => navigate("/settings/create-menu"),
            icons: <Bars3Icon className="icon-1" sx={{ fontSize: "1.5em", color: "#333" }} />,
            text: "Set Your Menu Items",
            hidden: isMobile,
          },
        ]
      : []),
    {
      name: "Quick Troubleshoot",
      // redirect: () => clearLC(),
      redirect: () => setActiveTabComp(<QuickTroubleshoot />),
      icons: <WrenchScrewdriverIcon className="icon-1" sx={{ fontSize: "1.5em", color: "#333" }} />,
      text: "Clear Local Storage",
      statusText: localStorage.getItem("profilerSwitch"),
      hidden: false,
    },
    {
      name: "Printer Configuration",
      // redirect: () => navigate("/settings/printer-configuration"),
      redirect: () => setActiveTabComp(<PrinterConfigurationSettings />),
      icons: (
        <LocalPrintshopOutlinedIcon className="icon-1" sx={{ fontSize: "1.5em", color: "#333" }} />
      ),
      text: "Change printer settings ",
      statusText: localStorage.getItem("profilerSwitch"),
      hidden: false,
    },
    ...(branchSubType === "FINE_DINE"
      ? [
          {
            name: "Printer Agent",
            redirect: () => setActiveTabComp(<PrinterAgent />),
            icons: (
              <SupportAgentIcon className="icon-1" sx={{ fontSize: "1.5em", color: "#333" }} />
            ),
            text: "Get Printer Agent",
            statusText: localStorage.getItem("profilerSwitch"),
            hidden: cloudPrintEnabled ? false : true,
          },
        ]
      : []),
    {
      name: "Toggle Full Screen",
      redirect: () => toggleFullScreen(),
      icons: (
        <ArrowTopRightOnSquareIcon className="icon-1" sx={{ fontSize: "1.5em", color: "#333" }} />
      ),
      text: "",
      hidden: false,
    },
  ];

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "ArrowUp" && activeIndex > 0) {
        setActiveIndex(activeIndex - 1);
      } else if (event.key === "ArrowDown" && activeIndex < items.length - 1) {
        setActiveIndex(activeIndex + 1);
      } else if (event.key === "Enter") {
        const itemName = items[activeIndex].name;
        items[activeIndex].redirect();

        // for menu and toggle don't set active index
        if (itemName === "Menu" || itemName === "Toggle Full Screen") {
          setActiveIndex(arrowActiveTab);
        } else {
          setArrowActiveTab(activeIndex);
        }
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [activeIndex, items.length]);

  const handleGridClick = (index) => {
    const itemName = items[index].name;

    // for menu and toggle full screen don't set active index
    if (itemName === "Menu" || itemName === "Toggle Full Screen") {
      items[index].redirect();
      return;
    }

    setActiveIndex(index);
    items[index].redirect();
  };

  // toggle full screen
  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  };

  // to change location
  const handleLocation = () => {
    if (sessionId) {
      showSnackbar("Close session to change location", "error");
    } else {
      navigate("/products/location");
    }
  };

  const handleEndDay = () => {
    if (sessionId) {
      showSnackbar("Close session to end day", "error");
    } else {
      navigate("/session-page/day/closing");
    }
  };

  return (
    <Navbar>
      <Box className="setting-container">
        <div className="setting-header-row-par">
          <p className="settings-title">Settings</p>
        </div>
        <div className="setting-wrapper-outer-par">
          <Box
            // p={2}
            className="setting-wrapper-box"
            // sx={{ flexDirection: { xs: "column", md: "row" } }}
          >
            {/* <Grid container spacing={2} className="main-grid-wrapper-box"> */}
            {items.map(
              (e, i) =>
                !e.hidden && (
                  // <Grid item lg={3} md={3} xs={12} key={i}>
                  <Box
                    key={i}
                    className={`grid-wapper-box ${
                      activeIndex === i ? "active-module-settings" : ""
                    }`}
                    onClick={() => handleGridClick(i)}
                  >
                    <Box className="inner-grid-wrapper-box">
                      <div className="settins-tab-icon-par">{e?.icons}</div>
                      <div>{e?.name}</div>
                      {/* <Box className="grid-wrapper-icon-box">{e.icons}</Box>
                        <Box className="dark-white-text">
                          <p>{e.name}</p>
                        </Box> */}
                      {/* <Box>
                          <p>{e.name}</p>
                          <p className="inner-text-content">{e.text}</p>
                        </Box> */}
                    </Box>
                    {/* <Box className="inner-text-grid-wrapper-box">
                        <p className="inner-text-content">{e.text}</p>
                      </Box> */}
                    {/* {!!e.statusText && (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            fontSize: "0.8rem",
                            marginRight: "0.5rem",
                            color: e.statusText === "true" ? "green" : "red",
                          }}
                        >
                          <p>{e.statusText === "true" ? "Profiler ON" : "Profiler OFF"}</p>
                        </Box>
                      )} */}
                  </Box>
                  // </Grid>
                )
            )}
            {/* </Grid> */}
          </Box>
          <div className="setting-main-output-screen">
            {/* render the selected tab component */}
            {activeTabComp}
          </div>
        </div>
      </Box>
    </Navbar>
  );
};

export default Settings;
